import { useEffect } from 'react';
import { useIsRegionalClient } from 'store/features/auth';
import { useIsAuthorizedUser } from 'common/hooks/useIsAuthorizedUser';
import { useApplicationOperations } from 'entities/application';

import { STATIONS_PRICE_REPORTS_URL_PARAM } from '../constants';
import { MODALS } from 'entities/application';

export const useShowStationsPriceReports = () => {
  const { addActiveModal } = useApplicationOperations();
  const isRegionalClient = useIsRegionalClient();
  const isAuthorizedUser = useIsAuthorizedUser();

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);

    if (isAuthorizedUser && !isRegionalClient && urlSearchParams.has(STATIONS_PRICE_REPORTS_URL_PARAM) ) {
      addActiveModal(MODALS.stationsPriceReport);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRegionalClient, addActiveModal, isAuthorizedUser]);
};
